import { Box, IconButton, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const ModalContent = styled(Box)({
	...flexMixin({ justify: 'flex-start', direction: 'column', gap: 24 }),
	width: '100%',
	margin: '48px',
	boxSizing: 'border-box',
});

export const ModalTitle = styled(Typography)({
	fontSize: '24px',
	fontWeight: '700',
	lineHeight: '133.4%',
	letterSpacing: '0px',
	color: 'rgb(16, 33, 66)',
});

export const TableTitle = styled(Typography)({
	color: 'rgb(16, 33, 66)',
	fontSize: '14px',
	fontWeight: '700',
	lineHeight: '152%',
	letterSpacing: '0.1px',
});

export const TableText = styled(Typography)({
	color: 'rgb(16, 33, 66)',
	fontSize: '16px',
	fontWeight: '400',
	lineHeight: '150%',
	letterSpacing: '0.15px',
});

export const DownloadButton = styled(IconButton)({
	padding: '10px',
	borderRadius: '40px',
	background: 'rgb(71, 134, 255)',

	'&.Mui-disabled': {
		background: 'rgb(71, 134, 255)',
		opacity: 0.5,
	},

	'& svg': {
		height: '20px',
		width: '20px',
	},

	'&:hover': {
		background: 'rgb(108, 158, 255)',
	},
});
